import React from "react";
import "./landing.css";
import "../styles.css";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import { StyledButton } from "../helpers/button";
import LandingImage from "../images/landingImage.png";
import { NavHashLink } from "react-router-hash-link";
const LandingPage = () => {
  return (
    <div style={{ paddingTop: 50, paddingBottom: 50 }} id="home">
      <Grid container>
        <Grid item md={6} xs={12} className={"gridContainer"}>
          <div className={"landing-page-content-container"}>
            <h1>
              Let's Grow Your <br />
              Business to the <br /> Next Level
            </h1>
            <div className={"buttonContainer"}>
              <StyledButton
                primary
                component={NavHashLink}
                spy={"true"}
                smooth={true}
                offset={-70}
                to={"#marketing"}
                duration={500}
              >
                Get Started
              </StyledButton>
              <StyledButton
                component={NavHashLink}
                spy={"true"}
                smooth={true}
                offset={-70}
                to={"#about"}
                duration={500}
                className={"specialButton"}
                special
                color={"#000"}
              >
                Explore more
              </StyledButton>
            </div>
          </div>
        </Grid>
        <Grid item md={6} xs={12} className={"gridContainer"}>
          <img
            src={LandingImage}
            className={"landingImage"}
            alt={"CellarTech"}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default LandingPage;
